import Lottie from "lottie-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { fetchChatGPT } from "../services/chat.service";
import useSnackbarStore from "../store/snackbarStore";
import { useMixPanel } from "../hooks/useMixPanel";
import { useMediaQuery } from "react-responsive";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
/* Components */
import FormAssess from "../components/form/formAssess";
import Button from "../components/button/button";
import TextArea from "../components/form-elements/TextArea/textArea";
import Popup from "../components/popup/popup";
import Toolbar from "../components/toolbar/toolbar";
import Icon from "../components/icon/icon";
import TextRotator from "../components/textRotator/textRotator";
/* Assets */
import ArrowBack from "../assets/icons/arrow_back.svg";
import ArrowLeft from "../assets/icons/switch_left.svg";
import ArrowRight from "../assets/icons/switch_right.svg";
import History from '../assets/icons/watch_later.svg';
/* Icons */
import Idea from "../assets/icons/idea.svg";
import Mod from "../assets/icons/mod.svg";
import Answers from "../assets/icons/answers.svg";
import Download from "../assets/icons/download.svg";
// import ShareIcon from "../assets/icons/ShareNetwork.svg";
import HistoryEmpty from "../assets/icons/history_toggle_off.svg";
/* Animations */
import soundWave from "../assets/animations/sounWave.json";
import ShaiaCreate from "../assets/shaia_create.png";
import useChatGPTStore from "../store/useChatGPT.store";
import useGlobalStore from "../store/useGlobalStore";
import {
  getSessionById,
  getSessionsByUseCase,
} from "../services/teacherSession.service";
import { v4 as uuidv4 } from "uuid";
import { MIX_PANEL_EVENTS } from "../utils/constans";
import UseCaseHistory from "../components/UseCaseHistory/UseCaseHistory";
import { htmlToMarkdown, htmlToPdf, htmlToPlainText } from "../utils/Utils";
import useCaseStore from "../store/useCaseStore";
import MentuEditor from "../components/MentuEditor/MentuEditor";
import useUsageStore from "../store/useUsageStore";
import useSessionStore from "../store/useSessionStore";
import { getUsage } from "../services/useCaseUsage.service";

const DesignAssessBoard = () => {
  const [toggle, setToggle] = useState(true);
  const [history, setHistory] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isToolsActive, setToolsActive] = useState(false);
  const [isInputActive, setInputActive] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showMaterialButton, setShowMateriaButton] = useState(true); // eslint-disable-line
  const [plan, setPlan] = useState(null);
  const [modifyIsRequired, setModifyIsRequired] = useState(false);
  const [text, setText] = useState("");
  const { t, i18n } = useTranslation();
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [parentSessionId, setParentSessionId] = useState(null);
  const [isView, setIsView] = useState(null);
  const {
    gptSuccess,
    setGPTSuccess,
    gptLoading,
    setGPTLoading,
    setGlobalClear, // eslint-disable-line
    setCreditAnimateClear,
  } = useGlobalStore(); // eslint-disable-line
  const { setClear, setIsFirsTimePlan } = useChatGPTStore();
  const { show } = useSnackbarStore();
  const { sendEvent } = useMixPanel();
  const [overlayON, setOverlayON] = useState(false);
  const [whichAction, setAction] = useState(""); // eslint-disable-line
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("sessionId");
  const sessionIdRef = useRef(null);
  const navigate = useNavigate();
  const isMaterialRef = useRef(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const modPopupRef = useRef(null);
  const {
    useCaseList,
    setAssesMessages,
    assesUserContext,
    setAssesUserContext,
    setAssesForm
  } = useCaseStore();
  const { setUsage } = useUsageStore();
  const { user } = useSessionStore();
  const nextActionRef = useRef("evaluacion");

  const currentUseCase = useCaseList?.find(
    (e) => e.description === "evaluacion"
  );
  const useCaseId = currentUseCase ? currentUseCase.id : null;
  const currentModifyUseCase = useCaseList?.find(
    (e) => e.description === "modificar-evaluacion"
  );
  const modifyUseCaseId = currentModifyUseCase ? currentModifyUseCase.id : null;

  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  const styleJSON_wave = {
    width: isMobile ? 174 : 254,
    height: isMobile ? 174 : 254,
    position: "absolute",
  };

  const texts = [
    `${t("principio_1")}`,
    `${t("principio_2")}`,
    `${t("principio_3")}`,
    `${t("principio_4")}`,
    `${t("principio_5")}`,
    `${t("principio_6")}`,
    `${t("principio_7")}`,
    `${t("principio_8")}`,
    `${t("principio_9")}`,
    `${t("principio_10")}`,
  ];

  // const getUseCaseNextAction = () => {

  //   switch (nextActionRef.current) {
  //     case "evaluacion":
  //       return useCaseId;
  //     case "modificar-evaluacion":
  //       return modifyUseCaseId;
  //     default:
  //       return useCaseId;
  //   }
  // };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
    if (isToolsActive && isMobile) {
      toggleClassTools();
    }
  };

  const questions = [
    { field: "clase", question: t("formulario_evaluacion_contexto_clase") },
    { field: "grado", question: t("formulario_evaluacion_contexto_grado") },
    { field: "edad", question: t("formulario_evaluacion_contexto_edad") },
    {
      field: "estandar",
      question: t("formulario_evaluacion_contexto_estandar"),
    },
    {
      field: "consideraciones",
      question: t("formulario_evaluacion_contexto_consideraciones"),
    },
    {
      field: "option1",
      question: t("formulario_evaluacion_contexto_verdadero_falso"),
    },
    {
      field: "option2",
      question: t("formulario_evaluacion_contexto_seleccion_multiple"),
    },
    {
      field: "option3",
      question: t("formulario_evaluacion_contexto_preguntas_abiertas"),
    },
  ];

  const getUsagemutation = useMutation(getUsage, {
    onSuccess: (data) => {
      setUsage({
        total: data?.total,
        limit: data?.limit,
        percentage: data?.usagePercentage,
      });
    },
    onError: () => {},
  });

  const sessionByIdMutation = useMutation(getSessionById, {
    onSuccess: (data) => {
      if (data?.data && data.data.session_id) {
        setGPTSuccess(true);
        setIsFirsTimePlan(true);
        setPlan(data.data.plan);
        setParentSessionId(data?.data?.parent_session_id || null);
        const arrayMessages = JSON.parse(data.data.memory_array);
        const userMessage = arrayMessages.find(
          (e) => e?.role === "user" || e?.type === "human"
        );
        const currentUserMessage =
          userMessage?.content || userMessage?.data?.content;
        if (data?.data?.parent_session_id) {
          const findParent = history?.find(
            (e) => e.session_id === data?.data?.parent_session_id
          );
          if (findParent) {
            const parseCurrentUserMessages = JSON.parse(findParent.memory_array);
            const conditions = ["Context:", "contextoUsuario"];
            const currentUserContextMessage = parseCurrentUserMessages.find(
              (e) =>
                (e?.role === "user" || e?.type === "human") &&
                conditions.some((s) => e.data.content.includes(s))
            );
            if (currentUserContextMessage) {
              const currentBuildForm =
                currentUserContextMessage?.content ||
                currentUserContextMessage?.data?.content;
            buildForm(currentBuildForm);
              setAssesUserContext(currentBuildForm);
            }
          }
        } else if (userMessage) {
          buildForm(currentUserMessage);
          setAssesUserContext(currentUserMessage);
        }

        setAssesMessages(arrayMessages);
      } else {
        setGPTSuccess(false);
      }
    },
    onError: (error) => {},
  });

  const teacherSessionMutation = useMutation(getSessionsByUseCase, {
    onSuccess: (res) => {
      setHistory(res);
    },
    onError: () => {},
  });

  const mutation = useMutation(fetchChatGPT, {
    onSuccess: (res) => {
      getUsagemutation.mutate(user?.email);
      setAssesMessages(res?.messages);
      setGPTLoading(false);
      setGPTSuccess(true);
      if (sessionIdRef.current) {
        navigate(`/design-assess?sessionId=${sessionIdRef.current}`);
        sessionByIdMutation.mutate(sessionIdRef.current);
      }
    },
    onSettled: () => {
      if (overlayON) {
        setOverlayON(false);
      }
    },
    onError: () => {
      setGPTLoading(false);
      setGPTSuccess(false);
      show("Ocurrio un error, vuelve a intentar", "error");
    },
  });

  function parseTextToKeyValuePairs(text) {
    // Divide el texto en segmentos por tres espacios, asumiendo dos después del valor
    const segments = text.split("  ");
    const keyValuePairs = {};

    segments.forEach((segment) => {
      // Divide cada segmento por el primer dos puntos encontrado
      const [key, value] = segment.split(":").map((part) => part.trim());
      keyValuePairs[key] = value;
    });

    return keyValuePairs;
  }

  const buildForm = (formContext) => {
    const extractedText = formContext.match(/```([\s\S]*?)```/)[1];
    const contextObject = parseTextToKeyValuePairs(extractedText);
    const parsedQuestions = Object.keys(contextObject).reduce((acc, value) => {
      const findCurrentQuestion = questions.find((e) => e.question === value);
      if (findCurrentQuestion) {
        return [
          ...acc,
          { field: findCurrentQuestion.field, value: contextObject[value] },
        ];
      }
      return acc;
    }, []);

    setAssesForm(parsedQuestions);
  };

  const toggleView = (buttonName, data) => {
    const arrayMessages = JSON.parse(data.memory_array);
    const conditions = ["Context:", "contextoUsuario"];
    const userMessage = arrayMessages.find(
      (e) =>
        (e?.role === "user" || e?.type === "human") &&
        conditions.some(
          (s) => e?.content?.includes(s) || e?.data?.content?.includes(s)
        )
    );
    let currentBuildForm = userMessage?.content;
    const findParent = history?.find(
      (e) => e.session_id === data?.parent_session_id
    );
    if (findParent) {
      const parseCurrentUserMessages = JSON.parse(findParent.memory_array);
      const currentUserContextMessage = parseCurrentUserMessages.find(
        (e) =>
          (e?.role === "user" || e?.type === "human") &&
          conditions.some(
            (s) => e?.content?.includes(s) || e?.data?.content?.includes(s)
          )
      );
      if (currentUserContextMessage) {
        currentBuildForm = currentUserContextMessage.content;
      }
    }

    if (gptSuccess) {
      setAssesMessages(arrayMessages);
      setIsFirsTimePlan(true);
      setPlan(data?.plan);
      setParentSessionId(data?.parent_session_id || null);
      buildForm(currentBuildForm);
      setAssesUserContext(currentBuildForm);
    }
    navigate(`/design-assess?sessionId=${data.session_id}`);
    setIsView(buttonName);
    if (isActive) {
      toggleClass();
    }
  };

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  const toggleClassTools = () => {
    setToolsActive(!isToolsActive);
  };

  const toggleInput = useCallback(() => {
    setInputActive(!isInputActive);
  }, [isInputActive]);

  const handleTextChange = (e) => {
    setText(e?.target?.value);
    if (e?.target?.value) setModifyIsRequired(false);
  };

  const toggleComponents = useCallback(() => {
    setToggle((toggle) => !toggle);
  }, []);

  const handleIdea = () => {
    setGPTLoading(true);
    setOverlayON(true);
    setAction("idea");
    sessionIdRef.current = uuidv4();
    nextActionRef.current = 'evaluacion';
    mutation.mutate({
      messages: [{ role: "user", content: assesUserContext }],
      type: "evaluacion",
      session_id: sessionIdRef.current,
      use_case_id: useCaseId,
      lang: i18n.language
    });
    sendEvent(MIX_PANEL_EVENTS.assessmentIdea);
    if (isToolsActive) {
      toggleClassTools();
    }
  };

  const handleCreateMaterials = () => {
    const plainTextContent = htmlToPlainText(plan);
    const userMessage = {
      role: "user",
      content: `${t(
        "prompt_editor_crear_respuesta"
      )} + ${plainTextContent}`,
    };
    setGPTLoading(true);
    setOverlayON(true);
    isMaterialRef.current = true;
    sessionIdRef.current = uuidv4();
    nextActionRef.current = 'generar-respuestas';
    mutation.mutate({
      messages: [userMessage],
      type: "generar-respuestas",
      option: "respuestas",
      session_id: sessionIdRef.current,
      parent_session_id: parentSessionId || sessionId,
      //plan,
      lang: i18n.language
    });
    sendEvent(MIX_PANEL_EVENTS.assessmentAnswers);
    if (isToolsActive) {
      toggleClassTools();
    }
    if (isPopupOpen) {
      togglePopup();
    }
  };

  const onModifySection = () => {
    if (!text) {
      setModifyIsRequired(true);
      return;
    }

    const plainTextContent = htmlToMarkdown(plan);
    const datToReplace = {
      plan: plainTextContent,
      input: text,
    };
    const newPrompt = t("prompt_editor_modificar_evaluacion").replace(
      /\{(\w+)\}/g,
      (placeholder, key) => {
        return datToReplace[key] || placeholder;
      }
    );
    sessionIdRef.current = uuidv4();
    nextActionRef.current = 'modificar-evaluacion';
    const payload = {
      messages: [
        {
          role: "user",
          content: newPrompt,
        },
      ],
      type: "modificar-evaluacion",
      session_id: sessionIdRef.current,
      parent_session_id: parentSessionId || sessionId,
      use_case_id: modifyUseCaseId,
      lang: i18n.language
    };
    setGPTLoading(true);
    setOverlayON(true);
    setAction("modify");

    mutation.mutate(payload);
    sendEvent(MIX_PANEL_EVENTS.assessmentModify);
    if (isToolsActive) {
      toggleClassTools();
    }
    if (isInputActive) {
      setInputActive(!isInputActive);
    }
  };


  const userInfoString = localStorage.getItem("user");
  const userInfo = JSON.parse(userInfoString || '{}'); 
  const fullName = `${user?.first_name || ''} ${user?.last_name || ''}`.trim() || user?.email || `${userInfo.first_name || ''} ${userInfo.last_name || ''}`.trim(); 

  const exportAsPDF = async () => {
    htmlToPdf("Evaluación", fullName);
    sendEvent(MIX_PANEL_EVENTS.assessmentDownloadPDF);
  };

  /*const handleShare = async () => {
    if (isMobile) {
      const plainTextContent = htmlToPlainText(plan);
      const pdfContent = {
        content: [
          { text: t("evaluacion_titulo_pdf"), style: "header" },
          { text: `${t("evaluacion_subtitulo_pdf")}:`, style: "subheader" },
          { text: plainTextContent },
        ],
        styles: {
          header: { fontSize: 18, bold: true },
          subheader: { fontSize: 14, bold: true },
        },
      };

      const pdfDoc = pdfMake.createPdf(pdfContent);

      pdfDoc.getBlob((blob) => {
        if (navigator?.share) {
          try {
            const pdfFile = new File([blob], "shaia-recurso.pdf", {
              type: "application/pdf",
            });
            navigator.share({
              title: "Compartir PDF",
              text: "Comparte este PDF",
              files: [pdfFile],
            });
          } catch (error) {
            console.error("Error al compartir el PDF:", error);
          }
        } else {
          console.log("El navegador no admite la API de compartir.");
        }
      });
      if (isToolsActive) {
        toggleClassTools();
      }
    } else {
      console.log("Este componente solo funciona en la versión móvil.");
    }
  };*/

  const trackBackEvent = () => {
    if (isMobile) {
      navigate('/');
    }
    setCreditAnimateClear();
    sendEvent(MIX_PANEL_EVENTS.assessmentBackHome);
  };

  const onPlan = (valuePlan) => {
    setPlan(valuePlan);
  };

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (windowSize.innerWidth <= 576 && gptSuccess) {
      toggleComponents();
    }
  }, [windowSize.innerWidth, gptSuccess, toggleComponents]);

  useEffect(() => {
    if (sessionId) {
      sessionByIdMutation.mutate(sessionId);
    }
    // eslint-disable-next-line
  }, [sessionId]);

  useEffect(() => {
    teacherSessionMutation.mutate("evaluacion");
    return () => {
      setClear();
      setGlobalClear();
      //setGPTSuccess(false);
    };
    // eslint-disable-next-line
  }, []);

  const handleCloseOutside = useCallback(
    (event) => {
      if (modPopupRef.current && !modPopupRef.current.contains(event.target)) {
        toggleInput();
      }
    },
    [toggleInput]
  );

  useEffect(() => {
    if (isInputActive) {
      document.addEventListener("mousedown", handleCloseOutside);
    } else {
      document.removeEventListener("mousedown", handleCloseOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleCloseOutside);
    };
  }, [isInputActive, handleCloseOutside]);

  return (
    <>
      { !isMobile && 
        <div className="back-button">
          <Link to={"/"} className="back-button_arrow" onClick={trackBackEvent}>
            <img src={ArrowBack} className="" alt="" />
            {t("inicio")}
          </Link>
          <span className="back_button_root">{t("assessText1")} /</span>
          <span className="back_button_page">{t("assessText2")}</span>
        </div>
      }
      {/* Para mostrar */}
      <div
        className={`wrapper d-dialog d-editor ${
          gptSuccess ? "editOn" : "editOff"
        }`}
      >
        <div
          className={`mobile-view${
            toggle ? "" : windowSize.innerWidth <= 576 ? " focus" : ""
          }`}
        >
          <div
            className={`editor_board-animation ${gptLoading ? "overlay" : ""}`}
          >
            <div className="animation-wrapper">
              <Lottie animationData={soundWave} style={styleJSON_wave} />
              <div className="wrapper-shaia_speak">
                <img src={ShaiaCreate} alt="Shaia" />
              </div>
            </div>
            <div className="content-text">
              <p>
                {t("espera_pagina_espera1")}. {t("espera_pagina_espera2")}.
              </p>
              <p>{t("espera_pagina_espera3")}:</p>
              <TextRotator texts={texts} interval={10000} />
            </div>
          </div>
          <div className={`chat_sidebar ${gptSuccess ? "editOn" : "editOff"}`}>
            <div className="sidebar_chat">
              <div className="chat-content">
                <div className="chat-content_title">
                  <div className="welcome-text">
                    <strong>{t("activityText3")}</strong> 👋
                    <br />
                    <br />
                    {gptSuccess ? (
                      <>{t("activityText4_alt")}.</>
                    ) : (
                      <>
                        {t("assessText4")}
                        <span className="blue-text">
                          {t("assessText5")}.
                        </span>{" "}
                        ¡{t("assessText6")}!
                      </>
                    )}
                  </div>
                </div>
                <div className="chat-content_wrapper">
                  <FormAssess />
                </div>
              </div>
            </div>
            <div className={`sidebar_history h-full max-h-desktopWrapper ${isActive ? "active" : ""}`}>
              <h6 className="blue-text sidebar-title">
                {t("historialTitulo")}
              </h6>
              {history.length ? (
                <UseCaseHistory
                  history={history}
                  sessionId={sessionId}
                  isView={isView}
                  toggleView={toggleView}
                />
              ) : (
                <>
                  <div className="history_empty">
                    <img src={HistoryEmpty} alt="empty" />
                    <p className="blue-text">{t("historialTituloVacio")}</p>
                  </div>
                </>
              )}
              <Button
                label="Cerrar"
                variant="primary-outline"
                onClick={toggleClass}
              />
            </div>
          </div>
          <div className={`editor_board`}>
            {/* <QuillEditor /> */}
            <MentuEditor plan={plan} onPlan={onPlan} />
          </div>
        </div>
        {gptSuccess && windowSize.innerWidth > 576 && (
          <Toolbar>
            <Icon
              icon={Idea}
              iconText={t("editor_barra_boton_idea")}
              onClick={() => handleIdea()}
              disabled={gptLoading}
              tooltipText={t("editor_barra_tooltip_idea")}
              disabledToolTip={isInputActive}
            />
            <Icon
              icon={Mod}
              iconText={t("editor_barra_boton_modificar")}
              onClick={() => toggleInput()}
              disabled={gptLoading}
              tooltipText={t("editor_barra_tooltip_modificar")}
              disabledToolTip={isInputActive}
            />
            {/* <Icon
              icon={Answers}
              iconText={t("editor_barra_boton_respuestas")}
              onClick={() => togglePopup()}
              disabled={gptLoading}
              tooltipText={t("editor_barra_tooltip_respuestas")}
              customClassName={!showMaterialButton ? "opacity-25" : ""}
              disabledToolTip={!showMaterialButton || isInputActive}
            /> */}
            <Icon
              icon={Download}
              iconText={t("editor_barra_boton_descargar")}
              onClick={() => exportAsPDF()}
              disabled={gptLoading}
              customClassName="download"
              tooltipText={t("editor_barra_tooltip_descargar")}
              disabledToolTip={isInputActive}
            />
            {isInputActive && (
              <div ref={modPopupRef} className="modPopup">
                <TextArea
                  value={text}
                  onChange={handleTextChange}
                  placeholder={t("tablero_modificar_resultado_subtitulo")}
                />
                {modifyIsRequired && (
                  <span className="error">{t("campo_requerido")}</span>
                )}
                <Button
                  variant="primary"
                  onClick={() => onModifySection()}
                  label={t("tablero_modificar_resultado_boton")}
                ></Button>
              </div>
            )}
          </Toolbar>
        )}
      </div>
      {isMobile && isInputActive && (
        <Popup isOpen={isInputActive} onClose={toggleInput}>
          <TextArea
            value={text}
            onChange={handleTextChange}
            placeholder={t("tablero_modificar_resultado_subtitulo")}
          />
          {modifyIsRequired && (
            <span className="error">{t("campo_requerido")}</span>
          )}
          <Button
            variant="primary"
            onClick={() => onModifySection()}
            label={t("tablero_modificar_resultado_boton")}
          ></Button>
        </Popup>
      )}     
      {showMaterialButton && (
        <Popup isOpen={isPopupOpen} onClose={togglePopup}>
          <div className="popup-wrapper">
            <h5>{t("popupCrearRespuestas_titulo")}</h5>
            <p>{t("popupCrearRespuestas_texto")}</p>
            <div className="popup-wrapper_Actions">
              <Button
                variant="primary-outline"
                onClick={() => togglePopup()}
                label={t("popupCrearMaterial_boton1")}
              ></Button>
              <Button
                variant="primary"
                onClick={() =>
                  showMaterialButton ? handleCreateMaterials() : null
                }
                label={t("popupCrearMaterial_boton2")}
              ></Button>
            </div>
          </div>
        </Popup>
      )} 
      {/* Bottom navbar */}
      { isMobile && 
        (
          <div className="fixed z-sticky bottom-0 left-0 w-screen h-16 bg-DarkBlue-700 px-4 flex flex-row gap-4 items-center justify-between">
            { toggle && 
              <Icon   
                icon={ArrowBack} 
                iconText={t("regresar")} 
                customClassName="gap-1 py-0 w-19" 
                onClick={trackBackEvent}
                disabledToolTip={true}
              />
            }
            { gptSuccess &&
              <>
                {!toggle &&
                  <>
                    <Icon
                      icon={Idea}
                      iconText={t("editor_barra_boton_idea")}
                      disabled={gptLoading || !gptSuccess}
                      onClick={() => handleIdea()}
                      customClassName={`gap-1 py-0 w-19 ${!gptSuccess && 'opacity-25'}`}
                      disabledToolTip={true}
                    />
                    <Icon
                      icon={Mod}
                      iconText={t("editor_barra_boton_modificar")}
                      onClick={() => toggleInput()}
                      disabled={gptLoading || !gptSuccess}
                      customClassName={`gap-1 py-0 w-19 ${!gptSuccess && 'opacity-25'}`} 
                      disabledToolTip={true}
                    />
                    <Icon
                      icon={Answers}
                      iconText={t("editor_barra_boton_respuestas")}
                      onClick={() => togglePopup()}
                      disabled={gptLoading || !gptSuccess}
                      customClassName={!showMaterialButton ? "opacity-25 gap-1 w-19" : `gap-1 py-0 w-19 ${!gptSuccess && 'opacity-25'}`}
                      disabledToolTip={true}
                    />
                    <Icon
                      icon={Download}
                      iconText={t("editor_barra_boton_descargar")}
                      onClick={() => exportAsPDF()}
                      disabled={gptLoading}
                      customClassName="download gap-1 w-19" 
                      disabledToolTip={true}
                    />  
                  </>
                }
                <Icon   
                  icon={toggle ? ArrowLeft : ArrowRight} 
                  iconText={toggle ? "Editor" : "Parámetros"}
                  customClassName="gap-1 py-0 w-19" 
                  onClick={toggleComponents}
                  disabledToolTip={true}
                />
              </>
            }
            { !gptSuccess && (
              <Icon 
                icon={History} 
                iconText={'Historial'} 
                customClassName="gap-1 w-19" 
                onClick={toggleClass}
                disabledToolTip={true}
              />
            ) }
          </div>
        )
      }
    </>
  );
};

export default DesignAssessBoard;

function getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}
